// extracted by mini-css-extract-plugin
export default {"nutrientsCardRow":"Rnz74ZYhCu_CduhjnXgW"};